import React, { useState, useEffect } from 'react';
import { Upload, Button, message, Image } from 'antd';
import { UploadOutlined, DeleteOutlined, EyeOutlined } from '@ant-design/icons';
import { uploadAPI } from '../services/api';
import { getImageUrl } from '../utils/getImageUrl';

const getPreviewSrc = (url) => {
  if (!url) return '';
  if (url.startsWith('data:image')) return url;
  return getImageUrl(url);
};

const ImageUpload = ({ value, onChange, disabled = false }) => {
  const [loading, setLoading] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(value || '');

  useEffect(() => {
    setPreviewUrl(value || '');
  }, [value]);

  const handleUpload = async (file) => {
    setLoading(true);
    try {
      // uploadAPI.uploadFile agora retorna os dados já desestruturados
      const response = await uploadAPI.uploadFile(file);
      const imagePath = response.url; // sempre caminho relativo
      setPreviewUrl(imagePath);
      onChange?.(imagePath);
      message.success('Imagem enviada com sucesso!');
    } catch (error) {
      message.error('Erro ao enviar imagem');
      console.error('Upload error:', error);
    } finally {
      setLoading(false);
    }
    return false; // Impede o upload automático do antd
  };

  const handleRemove = async () => {
    if (previewUrl) {
      try {
        const filename = previewUrl.split('/').pop();
        await uploadAPI.deleteFile(filename);
        setPreviewUrl('');
        onChange?.('');
        message.success('Imagem removida com sucesso!');
      } catch (error) {
        message.error('Erro ao remover imagem');
        console.error('Remove error:', error);
      }
    }
  };

  const beforeUpload = (file) => {
    const isImage = file.type.startsWith('image/');
    if (!isImage) {
      message.error('Você só pode enviar arquivos de imagem!');
      return false;
    }
    const isLt5M = file.size / 1024 / 1024 < 5;
    if (!isLt5M) {
      message.error('A imagem deve ter menos de 5MB!');
      return false;
    }
    return true;
  };

  return (
    <div>
      {previewUrl ? (
        <div style={{ marginBottom: 16 }}>
          <div style={{ marginBottom: 8 }}>
            <Image
              src={getPreviewSrc(previewUrl)}
              alt="Preview"
              style={{ maxWidth: 200, maxHeight: 200 }}
            />
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <Button
              icon={<EyeOutlined />}
              onClick={() => window.open(getPreviewSrc(previewUrl), '_blank')}
              size="small"
            >
              Ver
            </Button>
            <Button
              icon={<DeleteOutlined />}
              onClick={handleRemove}
              disabled={disabled || loading}
              danger
              size="small"
            >
              Remover
            </Button>
          </div>
        </div>
      ) : null}

      <Upload
        beforeUpload={beforeUpload}
        customRequest={({ file }) => handleUpload(file)}
        showUploadList={false}
        disabled={disabled || loading}
      >
        <Button
          icon={<UploadOutlined />}
          loading={loading}
          disabled={disabled}
          style={{ width: '100%' }}
        >
          {previewUrl ? 'Alterar Imagem' : 'Enviar Imagem'}
        </Button>
      </Upload>
    </div>
  );
};

export default ImageUpload;
